module.exports = __webpack_public_path__ + "img/5.6f000e63.png";